import { NotaryInstructions } from './NotaryInstructions'

export default NotaryInstructions
